import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import AntDTable from '../../Components/Table/AntDTable';
import toast from 'react-hot-toast';
import BtnExcel from '../../Components/BtnExcel';
import { formatDate, getTodayDateISO, validateSpaces } from '../../Utils/Common';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Modal,
    Form,
    Select,
    Input,
    AutoComplete,
    // InputNumber,
} from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'

const { Item } = Form;
const { Option } = Select;
const { Search } = Input;
const { confirm } = Modal;

const Property = () => {
  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [viewVisible, setViewVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [propertyId, setPropertyId] = useState('');
  const [pageSize, setPageSize] = useState('');
  const [propertyName, setPropertyName] = useState('');
  const [excelData, setExcelData] = useState([])
  const [subData, setSubData] = useState([])
  const [options, setOptions] = useState([])
  const [propertyDetails, setPropertyDetails] = useState({
      name: '',
      address:'',
      contact_person:'',
      contact_no: '',
      description: '',
      property_type: '',
  });
  const [filterConfig, setFilterConfig] = useState({
    search: '',
    type: '',
    property_id: '',
    page: 1,
  })
  const [propertyData, setPropertyData] = useState([])
  const [addForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const { callPost, loading } = usePostRequest(()=>{
    fetchPropertyData()
    addForm.resetFields();
    editForm.resetFields();
    setAddVisible(false);
    setEditVisible(false);
  });
  function ActionBtn(row) {
    const items = [
        {
            label: (
                <div onClick={()=>showViewModal(row.row.id, row.row)}>
                    View
                </div>
            ),
            key: '1',
        },
        {
            label: (
                <div onClick={()=>showEditModal(row.row.id, row.row)}>
                    Edit
                </div>
            ),
            key: '2',
        },
        {
            label: (
                <div style={{color: 'red'}} onClick={()=>showDeleteConfirm(row.row.id)}>
                    Delete
                </div>
            ),
            key: '3',
        },
    ];

    return (
      <>
        <span className='center'>
          <Dropdown
            menu={{
            items,
            }}
            trigger={['click']}
          >
            <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
              <Space>
                <MoreVert />
              </Space>
            </div>
          </Dropdown>
        </span>
      </>
    );
  }

  async function fetchPropertyData  () {
    setIsLoading(true)
    const response = await UseGetRequest("properties/get", filterConfig);
    if (response?.data) {
      setPropertyData(response?.data?.data);
      setPageSize(response?.data?.size)
    } else {
      setPropertyData([])
      setPageSize('')
    }

    setIsLoading(false);
  }

  async function fetchExportData() {
    setExportLoading(true)
    const response = await UseGetRequest("properties/get",
      {
        search: filterConfig.search,
        type: filterConfig.type,
        property_id: filterConfig.property_id,
      }
    );
    if (response?.data) {
      const property_data = response?.data?.data?.map((data) => ({
        id: data.id,
        name: data.name,
        address: data.address,
        contact_person: data.contact_person,
        contact_no: data.contact_no,
        description: data.description,
        property_type: data.property_type,
        sub_type: data.sub_type,
        added_on: data.added_on && formatDate(data.added_on),
        updated_on: data.updated_on && formatDate(data.updated_on),
      }))
      setExcelData(property_data)
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  }

  const handleAddOk = () => {
    addForm.validateFields().then(values => {
      callPost(
        "properties/create", 
        values,
        false
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };
  
  const handleEditOk = () => {
    editForm.validateFields().then(values => {
      const resetData = {
        ...values,
        property_id: propertyId
      }
      callPost(
        "properties/update", 
        resetData,
        false
      );      
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const showAddModal = () => {
    setAddVisible(true);
  };

  const showEditModal = (id, property_data) => {
    setPropertyId(id) 
    setPropertyDetails(() => ({
      name: property_data.name,
      address: property_data.address,
      contact_person: property_data.contact_person,
      contact_no: property_data.contact_no,
      description: property_data.description,
      property_type: property_data.property_type,
      sub_type: property_data.sub_type,
    })); 

    editForm.setFieldsValue({
      name: property_data.name,
      address: property_data.address,
      contact_person: property_data.contact_person,
      contact_no: property_data.contact_no,
      description: property_data.description,
      property_type: property_data.property_type,
      sub_type: property_data.sub_type,
    });
    setPropertyName(property_data?.property_type)
    setEditVisible(true);
  };

  const showViewModal = (id, property_data) => {
    setPropertyId(id) 
    setPropertyDetails(() => ({
      name: property_data.name,
      address: property_data.address,
      contact_person: property_data.contact_person,
      contact_no: property_data.contact_no,
      description: property_data.description,
      property_type: property_data.property_type,
      sub_type: property_data.sub_type,
    })); 
    setPropertyName(property_data?.property_type)
    setViewVisible(true);
  };

  const handleAddCancel = () => {
    addForm.resetFields();
    setAddVisible(false);
  };

  const handleEditCancel = () => {
    editForm.resetFields();
    setEditVisible(false);
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Do you want to permanently remove this property?',
      icon: <ExclamationCircleFilled/>,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      okButtonProps: {
        className: 'custom-yes-button',
      },
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      confirmLoading: loading,
      onOk() {
        callPost(
          "properties/delete", 
          {property_id: id},
          false
        );
      },
    });
  };

  
  
  // const validateContactNumber = (_, value) => {
  //   if (!value) {
  //     return Promise.resolve();
  //   }

  //   const isNumber = /^\d+$/.test(value);
  //   if (!isNumber) {
  //     return Promise.reject('Invalid Contact Number');
  //   }
  //   return Promise.resolve();
  // };

  const onProperty = (e) => {
    setPropertyName(e)
  };  

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };

  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const onSearchType = (e) => {
    setFilterConfig((prev) => (
      { 
        ...prev,
        type: e || '',
        page: 1,
      }
    ));
  };  

  const fetchOptions = (value) => {
    const data = subData
    return data
        .filter(item => item?.value?.toLowerCase().includes(value?.toLowerCase()))
        .map(item => ({ value: item?.value }));
  };

  const handleonSearch = (value) => {
      const fetchedOptions = fetchOptions(value);
      setOptions(fetchedOptions);
  };

  const handleOnSelect = (value) => {
      const item = options.find(option => option.value === value);
      addForm.setFieldsValue({
        sub_type: item.value
      });
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchPropertyData();
    fetchExportData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  useEffect(() => {
    if(propertyName === "commercial_building"){
      setSubData([
        {
          value: "Office Space",
        },
        {
          value: "Warehouse",
        },
        {
          value: "Bulding",
        },
        {
          value: "Parking",
        }
      ])
    } else if (propertyName === "residential_building") {
      setSubData([
        {
          value: "Apartment",
        },
        {
          value: "Condominium",
        },
        {
          value: "Townhouses",
        },
        {
          value: "Building",
        },
        {
          name: "Parking",
        }
      ])
    } else {
      setOptions([])
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyName]);

  return (
    <Layout className='page'>
        <Navbar navKey={'property_nav'}/>
        <Layout className='content-container overflow-y'>
          <Row className='custom-padding responsive-tab-inline'>
            <Col span={9} className='header-container'>
              PROPERTY
            </Col>
            <Col span={15} className='mt-2 responsive-tab-width' align='end'>
              <Space className='responsive-inline'> 
                <BtnExcel
                  label={"Export to Excel"}
                  size={"sm"}
                  excelData={excelData}
                  xlsxHeaders={[
                    "ID",
                    "Property Building",
                    "Property Address",
                    "Contact Person",
                    "Contact Number",
                    "Description",
                    "Property Type",
                    "Sub Type",
                    "Added On",
                    "Updated On",
                  ]}
                  handleData={fetchExportData}
                  isClicked={exportLoading}
                  fileName={`Property_${getTodayDateISO()}.xlsx`}
                />
                <Button 
                  className='button-color responsive-header-btn' 
                  onClick={showAddModal} 
                  type="primary"
                >
                  + Add Property
                </Button>
              </Space>
            </Col>
          </Row>
          <Row>
            <Space span={24} className='responsive-inline excel-row'>
              <Search
                placeholder="Search..."
                size='medium'
                onSearch={(e)=>handleSearchChange(e)}
                onChange={(e)=>handleEmpty(e)}
                className='responsive-header-input'
              />              
              <Select
                placeholder="Select Property Type"
                onChange={(e)=>onSearchType(e)}
                placement='bottomLeft'
                className='select-field responsive-header-input'
                align='left'
                options={[
                  {
                    value: '',
                    label: 'All',
                  },
                  {
                    value: 'residential_building',
                    label: 'Residential Building',
                  },
                  {
                    value: 'commercial_building',
                    label: 'Commercial Building',
                  },
                  {
                    value: 'raw_lot',
                    label: 'Raw Lot',
                  },
                  // {
                  //   value: 'condominium',
                  //   label: 'Condominium',
                  // },
                ]}
              />    
            </Space>
          </Row>
          <Row className='page-content'>
            <Col span={24} className='responsive-overflow-auto'>
              <AntDTable
                tableHeaders={[
                  "Property Building",
                  "Property Address",
                  "Contact Person",
                  "Contact Number",
                  "Property Type",
                  "Sub Type",
                  // "Description",
                ]}
                headerSelector={[
                  "name",
                  "address",
                  "contact_person",
                  "contact_no",
                  "property_type",
                  "sub_type",
                  // "description",
                ]}
                tableData={propertyData}
                ActionBtn={(row) => ActionBtn(row)}
                withAction={true}
                loading={isLoading}
                tablePages={10}
                handleTableChange={handleTableChange}
                filterConfig={filterConfig}
                totalSize={pageSize}
                isSearch={true}
              />
            </Col>
          </Row>
        </Layout>
        <Modal
          title="Add Property"
          confirmLoading={loading}
          open={addVisible}
          onOk={handleAddOk}
          onCancel={handleAddCancel}
          okText="Submit"
          maskClosable={false}
        >
          <Form 
            form={addForm} 
            layout="vertical"
          >
              <Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: 'Please enter your Name!' },
                    { validator: validateSpaces }
                  ]}
                  
              >
                  <Input />
              </Item>
              <Item
                  label="Property Address"
                  name="address"
                  rules={[
                    { required: true, message: 'Please enter your Property Address!' },
                    { validator: validateSpaces }
                  ]}
              >
                  <Input />
              </Item>
              <Item
                  label="Contact Person"
                  name="contact_person"
                  // rules={[
                  //   { required: true, message: 'Please enter your confirm Contact Person!' },
                  //   { validator: validateSpaces }
                  // ]}
              >
                  <Input />
              </Item>
              <Item
                  label="Contact Number"
                  name="contact_no"
                  // rules={
                  //   [
                  //     { 
                  //       required: true, 
                  //       message: 'Please enter your Contact Number!' 
                  //     },
                  //     {
                  //       validator: validateContactNumber
                  //     },
                  //     { validator: validateSpaces }
                  //   ]
                  // }
              >
                <Input/>
              </Item>
              <Item
                  label="Description"
                  name="description"
                  // rules={[
                  //   { required: true, message: 'Please enter your Description!' },
                  //   { validator: validateSpaces }
                  // ]}
              >
                  <Input />
              </Item>
              <Item
                  label="Type"
                  name="property_type"
                  rules={[{ required: true, message: 'Please select your Property' }]} // Adjusted message
              >
                <Select placeholder="Select a property" onChange={(e) => onProperty(e)}>
                  <Option value="commercial_building">Commercial Building</Option>
                  <Option value="raw_lot">Raw Lot</Option>
                  <Option value="residential_building">Residential Building</Option>
                  {/* <Option value="condominium">Condominium</Option> */}
                </Select>
              </Item>
              {
                (propertyName === "commercial_building" || propertyName === "residential_building") && (
                  <Item
                    label="Sub Type"
                    name="sub_type"
                    rules={[{ required: true, message: 'Please select your Property Type' }]} // Adjusted message
                  >
                    <AutoComplete
                      options={options}
                      onSearch={handleonSearch}
                      onSelect={handleOnSelect}
                      placeholder="Search or Add New"
                    >
                      <Input/>
                    </AutoComplete>
                  </Item>
                )
              }
          </Form>
        </Modal>
        <Modal
          title="Edit Property"
          confirmLoading={loading}
          open={editVisible}
          onOk={handleEditOk}
          onCancel={handleEditCancel}
          okText="Save"
          maskClosable={false}
        >
          <Form 
            form={editForm} 
            layout="vertical"
            initialValues={propertyDetails}
          >
            <Item
              label="Name"
              name="name"
              rules={[
                { required: true, message: 'Please enter your Name!' },
                { validator: validateSpaces }
              ]}
            >
              <Input />
            </Item>
            <Item
              label="Property Address"
              name="address"
              rules={[
                { required: true, message: 'Please enter your Property Address!' },
                { validator: validateSpaces }
              ]}
            >
              <Input />
            </Item>
            <Item
              label="Contact Person"
              name="contact_person"
              // rules={[
              //   { required: true, message: 'Please enter your confirm Contact Person!' },
              //   { validator: validateSpaces }
              // ]}
            >
              <Input/>
            </Item>
            <Item
              label="Contact Number"
              name="contact_no"
              // rules={
              //   [
              //     { 
              //       required: true, 
              //       message: 'Please enter your Contact Number!' 
              //     },
              //     {
              //       validator: validateContactNumber
              //     },
              //     { validator: validateSpaces }
              //   ]
              // }
            >
              <Input/>
            </Item>
            <Item
              label="Description"
              name="description"
              // rules={[{ required: true, message: 'Please enter your Description!' }]}
            >
              <Input />
            </Item>
            <Item
              label="Type"
              name="property_type"
              rules={[{ required: true, message: 'Please select your Property' }]} // Adjusted message
            >
              <Select placeholder="Select a property" onChange={(e) => onProperty(e)}>
                <Option value="commercial_building">Commercial Building</Option>
                <Option value="raw_lot">Raw Lot</Option>
                <Option value="residential_building">Residential Building</Option>
              </Select>
            </Item>
            {
                (propertyName === "commercial_building" || propertyName === "residential_building") && (
                  <Item
                    label="Sub Type"
                    name="sub_type"
                    rules={[{ required: true, message: 'Please select your Property Type' }]} // Adjusted message
                  >
                    <AutoComplete
                      options={options}
                      onSearch={handleonSearch}
                      onSelect={handleOnSelect}
                      placeholder="Search or Add New"
                    >
                      <Input/>
                    </AutoComplete>
                  </Item>
                )
              }
        </Form>
      </Modal>
      <Modal
        title="View Property"
        confirmLoading={loading}
        open={viewVisible}
        // onOk={handleEditOk}
        onCancel={() => setViewVisible(false)}
        okText="Save"
        maskClosable={false}
        width={800}
        footer={null} 
      >
        <Row className='mb-4'>
          <Col span={12}>
              <Space direction='vertical'>
                <div className='view-text'>Property Name: </div>
                {propertyDetails.name}
              </Space>
          </Col>
          <Col span={12}>
              <Space direction='vertical'>
                <div className='view-text'>Property Address: </div>
                {propertyDetails.address}
              </Space>
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col span={12}>
              <Space direction='vertical'>
                <div className='view-text'>Contact Person: </div>
                {propertyDetails.contact_person}
              </Space>
          </Col>
          <Col span={12}>
              <Space direction='vertical'>
                <div className='view-text'>Contact Number: </div>
                {propertyDetails.contact_no}
              </Space>
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col span={12}>
              <Space direction='vertical'>
                <div className='view-text'>Property Type: </div>
                {propertyDetails.property_type}
              </Space>
          </Col>
          <Col span={12}>
              <Space direction='vertical'>
                <div className='view-text'>Sub Type: </div>
                {propertyDetails.sub_type}
              </Space>
          </Col>
        </Row>
        <Row className='mb-4'>
          <Col span={12}>
              <Space direction='vertical'>
                <div className='view-text'>Description: </div>
                {propertyDetails.description}
              </Space>
          </Col>
        </Row>
      </Modal>
    </Layout>
  )
}

export default Property
